export const separators = {
  twoPoints: ':',
  slash: '/',
  space: ' ',
  emptyNumber: '-',
  comma: ',',
  dot: '.',
  dbItemSeparator: ':|:',
  dbNameSeparator: ':-:',
};
